import React from 'react';
import ReactDOM from 'react-dom';
import CategoriesMenuTransformed from './CategoriesMenu';

const element = typeof document !== 'undefined' && document.querySelector('#CategoriesMenu-component');

if (element) {
    const props = window.initialData.CategoriesMenu;

    ReactDOM.render(<CategoriesMenuTransformed {...props} />, element);
}

export default CategoriesMenuTransformed;
